import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { AutoComplete } from 'antd'

const { Option } = AutoComplete

@observer
class DestionationPoints extends Component {

  onStreetSelect = (value, option) => {
    this.props.setStreet(option.props.streetid, option.props.streettype === 1 ? true : false, option.props.iter, option.props.label)
  }

  onStreetSearch = (searchText, i) => {
    this.setState({
      streetValue: searchText,
      houseValue: '',
    })
    if(searchText.length > 2){
      this.props.getStreets(this.props.clientPhone, searchText, i)
    }    
  }

  onHouseSearch = (searchField, i) => {
    this.setState({
      houseValue: searchField,
    })
    const house = searchField ? searchField : false
    this.props.getHouse(house, i)
  }

  onHouseSelect= (value, option) => {
    this.props.setHouse(option.props.label, option.props.iter, option.props.label)
  }

  render() {
    const { iter } = this.props

    const dataSource = this.props.findedStreets[iter].map( street => {
      const optionKey = `${street.namerus} ${street.id}`;
      return (<Option
        key={optionKey}
        streetid={street.id}
        label={street.namerus}
        streettype={street.streettype}
        geox={street.geox}
        geoy={street.geoy}
        iter={iter}
      >
        {street.streettype === 0 ? street.namerus : street.namerus}
      </Option>)
    })

    const houseDataSource = this.props.findedHouses[iter].map( house => {
      const optionKey = `${house.id} ${house.geox}`;
      return (<Option
        key={optionKey}
        houseid={house.id}
        label={house.value}
        geox={house.geox}
        geoy={house.geoy}
        iter={iter}
      >
        {house.value}
      </Option>)
    })

    return (
      <>
        <div className="row order-row">
          <div className="col">
            <AutoComplete
              dataSource={dataSource}
              onSelect={this.onStreetSelect}
              onSearch={text => this.onStreetSearch(text, iter)}
              onChange={text => this.props.onChangeStreet(text, iter)}
              className="form-control webcab-field"
              placeholder="Улица *"
              value={this.props.selectedStreet[iter]}
            />
          </div>
          <div>
            
          </div>
        </div>
        <div className="row order-row">
          <div className="col-4">
            <AutoComplete
              dataSource={houseDataSource}
              onSelect={this.onHouseSelect}
              onSearch={text => this.onHouseSearch(text, iter)}
              onChange={text => this.props.onChangeHouse(text, iter)}
              className="form-control webcab-field"
              disabled={this.props.isPOI[iter]}
              placeholder="Дом *"
              value={this.props.selectedHouse[iter]}
            />
          </div>
          {this.props.clearBtn ? 
            (<div className="">
              <button className="btn-remove" onClick={ () => this.props.removeDestinationRow(iter)}></button>
            </div>)
          : null}
          
          <div>
            
          </div>
        </div>
      </>
    )
  }
}

const withData = inject(stores => ({
  clientPhone: stores.LoginFromStore.clientPhone,
  getStreets: stores.OrderStore.getStreets,
  streetsId: stores.OrderStore.streetsId,
  findedStreets: stores.OrderStore.findedStreets,
  setStreet: stores.OrderStore.setStreet,
  isPOI: stores.OrderStore.isPOI,
  getHouse: stores.OrderStore.getHouse,
  findedHouses: stores.OrderStore.findedHouses,
  setHouse: stores.OrderStore.setHouse, 
  houses: stores.OrderStore.houses,
  removeDestinationRow: stores.OrderStore.removeDestinationRow,
  getRouteAndPrice: stores.OrderStore.getRouteAndPrice,
  selectedStreet: stores.OrderStore.selectedStreet,
  selectedHouse: stores.OrderStore.selectedHouse,
  onChangeStreet: stores.OrderStore.onChangeStreet,
  onChangeHouse: stores.OrderStore.onChangeHouse,
}))

export default withData(DestionationPoints);
